import { MenuItem } from 'primeng/api';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { MessagesService } from '@core/_services/messages.service';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { ApiV6Service } from '@service/apiv6.service';

@Component({
    selector: 'app-add-user',
    templateUrl: './add-user.component.html',
    styleUrls: ['./add-user.component.scss'],
})
export class AddUserComponent implements OnInit {

    @Input()
    public userListDelegate: any;

    @Input()
    public groupListBase: any;

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDelete: EventEmitter<any> = new EventEmitter();

    public items: Array<MenuItem>;

    constructor(
        private api: ApiV6Service,
        protected _messageService: MessagesService,
        private translate: TranslateService) {
        }

    ngOnInit() {
    }

    public async validate(data) {
        let wRes: any = {};
        // id de la requête forcé à 0 : création
        data.id = 0;
        data.data.id = 0;
        data.data.autogenerated = false;
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('setuserdata', data));
            this.onValidate.emit({ data: wRes });
        } catch (error) {
            if (error.error.Message === 'Exist') {
                this._messageService.addWarn(this.translate.instant('Cf_UserExist', {user: data.data.login}));
            } else {
                if (error.error.CodeMessage === 'Pass_KO') {
                    this._messageService.addErrorMsg(error.error.Message);
                } else {
                    this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
                }
            }
        }
    }

    cancel() {
        this.onCancel.emit({ id: null });
    }
}
